import { render, staticRenderFns } from "./DeliveryZoneForm.vue?vue&type=template&id=5a842e84&"
import script from "./DeliveryZoneForm.vue?vue&type=script&lang=ts&"
export * from "./DeliveryZoneForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports